export default __webpack_public_path__ + "static/media/edit.3a79aa5d.svg";